import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import KycDialog from "../../components/KycDialog";
import MentorVerificationStatusDialog from "../../components/MentorVerificationStatusDialog";
import { getMentorVerificationList } from "../../services/mentor_verfication.service";
import Utils from "../../utils";
import Constants from "../../data/Constants";

const headerStyle = {
  fontWeight: "bold",
};

function MentorVerification(props) {
  const { setProgress, setToast, isRefreshed } = useOutletContext();
  const [data, setData] = useState(false);
  const [selectedKyc, setSelectedKyc] = useState(false);
  const [update, setUpdate] = useState(0); // change the value to rerender
  const [mentorVerificationStatus, setMentorVerificationStatus] =
    useState(false);

  const viewKycButtonHandler = (data) => {
    setSelectedKyc(data.kyc);
  };

  function CustomRow(props) {
    const { row, index, skipValue } = props;

    return (
      <>
        <TableRow key={row._id}>
          <TableCell>{index + 1 + skipValue}</TableCell>
          <TableCell>
            {row.user.firstname
              ? row.user.firstname + " " + row.user.lastname
              : "-"}
          </TableCell>
          <TableCell>{row.status}</TableCell>
          <TableCell>
            <Link to={"/dashboard/mentor/" + row.mentorId}>
              <a> {row.mentorId ?? "Not Set"}</a>
            </Link>
          </TableCell>
          <TableCell>{row.failedReason ?? "Not Set"}</TableCell>
          <TableCell>
            {moment(row.createdAt).format("dddd, MMMM Do YYYY, h:mm a")}
          </TableCell>
          <TableCell>
            <div className="flex gap-5">
              <Button size="small" onClick={(e) => viewKycButtonHandler(row)}>
                View KYC
              </Button>

              {row.status === "PENDING" ? (
                <>
                  <Button
                    size="small"
                    color="success"
                    variant="contained"
                    onClick={(e) =>
                      setMentorVerificationStatus({
                        status: "SUCCESS",
                        id: row._id,
                      })
                    }
                  >
                    Approve
                  </Button>

                  <Button
                    size="small"
                    color="error"
                    variant="contained"
                    onClick={(e) =>
                      setMentorVerificationStatus({
                        status: "FAILED",
                        id: row._id,
                      })
                    }
                  >
                    Decline
                  </Button>
                </>
              ) : null}
            </div>
          </TableCell>

          {/* <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => {
              setOpen(!open);
            }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell> */}
        </TableRow>
      </>
    );
  }

  useEffect(() => {
    setProgress(true);

    async function api() {
      try {
        const data = await getMentorVerificationList();
        if (data) {
          setData(data);
          setProgress(false);
        } else {
          // error

          setProgress(false);
          setToast({ error: true, message: Constants.Error.UNKNOWN });
        }
      } catch (error) {
        // error

        setProgress(false);
        setToast({ error: true, message: Constants.Error.UNKNOWN });
      }
    }
    api();
  }, [update, isRefreshed]);

  return (
    <div>
      <Box style={{ width: "100%" }}>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell style={headerStyle}>ID</TableCell>
                <TableCell style={headerStyle}>Fullname</TableCell>
                <TableCell style={headerStyle}>Status</TableCell>
                <TableCell style={headerStyle}>Mentor Profile</TableCell>
                <TableCell style={headerStyle}>Failed Reason</TableCell>
                <TableCell style={headerStyle}>Created At</TableCell>
                <TableCell style={headerStyle}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data
                ? data.map((row, index) => {
                    return (
                      <CustomRow
                        row={row}
                        key={index}
                        index={index}
                        skipValue={0}
                      />
                    );
                  })
                : null}
            </TableBody>
          </Table>
          {/* <div style={{ marginTop: '20px', textAlign: 'center' }} hidden={survey.length != 0}>
                No data with given filters
            </div> */}
        </TableContainer>

        {/* <TablePagination
          rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
          component="div"
          count={totalRows}
          rowsPerPage={filters.perPage}
          page={filters.page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        /> */}

        <KycDialog setSelectedKyc={setSelectedKyc} selectedKyc={selectedKyc} />
        <MentorVerificationStatusDialog
          setMentorVerificationStatus={setMentorVerificationStatus}
          mentorVerificationStatus={mentorVerificationStatus}
          setToast={setToast}
          onUpdate={() => {
            setUpdate(update + 1);
          }}
        />
      </Box>
    </div>
  );
}

export default MentorVerification;
